import { JsonSchema7 } from '@jsonforms/core';

import { ajv } from 'utils/ajv';

export const validateCustomForm = (
  validation: Array<JsonSchema7>,
  data: any,
) => {
  if (validation.length === 0) return true;

  const isValidated = validation.reduce((prev, current) => {
    const validate = ajv.compile(current);
    //if data is undefined there are cases where it will return true
    //e.g minLength: 5
    if (!data) return false;

    return prev || !!validate(data);
  }, false);

  return isValidated;
};
